import styled from "styled-components"
import { BreakPoints, media } from "../../helpers/rwd"
import { WidgetsWrapperStyles } from "./widgets-set-styles"

export const WidgetsWrapper = styled.div`
  ${media.max(BreakPoints.desktop)} {
    display: flex;
    justify-content: space-between;
    width: 100%;
    & > *:not(:last-child) {
      margin-right: 10px;
    }
  }
  ${media.max(BreakPoints.tablet)} {
    flex-direction: column;
    align-items: center;
    & > *:not(:last-child) {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
  ${WidgetsWrapperStyles}
`
